import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const { pathname, search } = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-display uppercase tracking-widest text-sm text-muted-foreground">Laden…</div>
      </div>
    );
  }
  if (!user) {
    const next = pathname !== "/" ? `?next=${encodeURIComponent(pathname + search)}` : "";
    return <Navigate to={`/login${next}`} replace />;
  }
  return children;
}
